export const LOGO_SRC = "/logo.png";

export const LogoMark = ({ className = "h-12 w-12" }) => (
  <img src={LOGO_SRC} alt="Logo TroiDéo — impression et modélisation 3D sur demande" className={`${className} rounded-xl object-cover`} />
);

export default function Logo() {
  return (
    <span className="flex items-center gap-3">
      <LogoMark className="h-11 w-11" />
      <span className="hidden font-mono text-[10px] uppercase tracking-[0.22em] text-neutral-500 sm:inline">
        Atelier 3D
      </span>
    </span>
  );
}
